/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Success toast timing helper for ViewAppointments.
 * @module pages/viewAppointments/viewAppointmentsSuccessMessage
 */

import {
  SUCCESS_ANIMATION_MS,
  SUCCESS_DISPLAY_MS,
} from "./viewAppointmentsConstants.js";

/**
 * Shows a success toast, then slides it away after the configured delay.
 * @param {Object} options
 * @param {function(boolean): void} options.setSlidingUp
 * @param {function(boolean): void} options.setVisible
 */
export const scheduleSuccessMessageHide = ({ setSlidingUp, setVisible }) => {
  setTimeout(() => {
    setSlidingUp(true);
    setTimeout(() => {
      setVisible(false);
      setSlidingUp(false);
    }, SUCCESS_ANIMATION_MS);
  }, SUCCESS_DISPLAY_MS);
};
